<template>
  <div v-cloak v-if="isDesktop" class="adv-item rating position-relative h-100 d-inline-block float-left mr-4"
    @mouseleave="hideRatingWithDelay">
    <span class="position-relative" @mouseover="
      fetchRating();
    showRating = true;
    ">
      <StarRating :inline="true" :rating="ratingForStarsComp" :read-only="true" :increment="0.01" :show-rating="false"
        :max-rating="5"></StarRating>
      {{ starsRating }} / 5,0
      {{ $translate("maversandVuePlugin::Additional.topbarRatingStars") }}

      <sup>
        <a href="#" class="text-dark" @click.prevent="scrollToDisclaimer">1</a>
      </sup>

      <div v-show="scoreCount !== null && showRating" class="dropdown-menu" @mouseover="isMouseOverDropdown = true"
        @mouseleave="isMouseOverDropdown = false" style="display: block; position: absolute; z-index: 1000">
        <div class="rating-container" v-for="(name, key) in criteriaName" :key="key">
          <div class="rating-name">{{ name }}</div>

          <div class="stars">
            <div class="filled-stars" :style="{ width: (criteriaValue[key] / 5) * 100 + '%' }">
              <svg v-for="n in 5" :key="n" class="star" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round"
                stroke-linejoin="round">
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                </polygon>
              </svg>
            </div>
            <!-- Empty Stars (Foreground Layer) -->
            <div class="empty-stars">
              <svg v-for="n in 5" :key="n" class="star" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round"
                stroke-linejoin="round">
                <polygon
                  points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                </polygon>
              </svg>
            </div>
          </div>

          <div class="criteria-rating">
            {{ criteriaValue[key] }}
          </div>
        </div>

        <div class="dropdown-divider"></div>
        <div class="owl-carousel rating-carousel owl-theme" style="max-width: 30em">
          <div v-for="(review, index) in latestReview" :key="index">
            <a class="dropdown-item review-text" href="https://www.shopvote.de/bewertung_ma_versand_de_9786.html">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5.52 19c.64-2.2 1.84-3 3.22-3h6.52c1.38 0 2.58.8 3.22 3" />
                <circle cx="12" cy="10" r="3" />
                <circle cx="12" cy="12" r="10" />
              </svg>
              {{ truncatedReviews[index] }}</a>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import axios from "axios";
import StarRating from "vue-star-rating";

export default {
  name: "rating",
  components: {
    StarRating,
  },
  data() {
    return {
      starsRating: "4,69",
      scoreCount: null,
      latestReview: "",
      showRating: false,
      isMouseOverDropdown: false,
      criteriaName: null,
      criteriaCount: null,
      criteriaValue: null,
      isDataFetched: false,
      ratingForStarsComp: 4.7,
      isDesktop: false,
    };
  },
  computed: {
    truncatedReviews() {
      return this.latestReview.map((review) => {
        if (review.length > 150) {
          let end = 150;
          while (end < review.length && review[end] !== " ") {
            end++;
          }
          return review.substring(0, end).trim() + "....";
        }
        return review;
      });
    },
  },
  methods: {
    async fetchRating() {
      if (this.isDataFetched) return;
      try {
        const url = "https://ma-versand.webimpact.app/api/shop-vote/ratings";
        const response = await axios({
          url: url,
          method: "get",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        });
        if (
          response.data &&
          response.data.rating_summary &&
          response.data.rating_summary.ratings_value &&
          response.data.rating_summary.ratings_value.stars
        ) {
          this.ratingForStarsComp = parseFloat(
            parseFloat(
              response.data.rating_summary.ratings_value.stars
            ).toFixed(2)
          );
        } else {
          console.error("Rating data is not available");
        }
        this.starsRating = response.data.rating_summary.ratings_value.stars;
        this.scoreCount = response.data.rating_summary.scoreCount;
        this.criteriaName = response.data.rating_summary.criteria_name;
        this.criteriaCount = response.data.rating_summary.criteria_count;
        this.criteriaValue = response.data.rating_summary.criteria_value;
        this.isDataFetched = true;
        if (response.data.reviews.review.length > 0) {
          this.latestReview = response.data.reviews.review
            .filter((review) => parseFloat(review.review_rating) === 5.0)
            .slice(0, 5)
            .map((r) => r.text);
        }
      } catch (err) {
        console.log(err);
      }
    },
    scrollToDisclaimer() {
      const element = document.getElementById("shopvote-disclaimer");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    formatRating(rating) {
      return rating.replace(".", ",");
    },
    checkScreenWidth() {
      this.isDesktop = window.innerWidth >= 992;
    },
    hideRatingWithDelay() {
      setTimeout(() => {
        if (!this.isMouseOverDropdown) {
          this.showRating = false;
        }
      }, 900); // 0.9 seconds
    },
  },
  mounted() {
    this.checkScreenWidth();
    window.addEventListener('resize', this.checkScreenWidth);
    this.fetchRating().then(() => {
      this.$nextTick(() => {
        if ($(".owl-carousel.rating-carousel").length > 0) {
          $(".owl-carousel.rating-carousel").owlCarousel({
            loop: true,
            margin: 10,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 4500,
            items: 1,
          });
        } else {
          console.log("no elem");
        }
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth);
  },
};
</script>

